import React, { Component } from 'react'
import { connect } from 'react-redux'
import authSelector from '../../selectors/authSelector'
import profileSelector from '../../selectors/profileSelector'
import { FETCH_USER_PROFILE } from '../../actions/actions'
import { isEmptyObject } from '../../helpers/utility'
import Splitter from '../../helpers/Splitter'

const ComponentByUserType = {
  STUDENT: Splitter(() => import('../student/StudentProfileShow')),
  TEACHER: Splitter(() => import('../teacher/TeacherProfileShow')),
  SCHOOL: Splitter(() => import('../school/SchoolProfileShow')),
  MANAGER: Splitter(() => import('../manager/ManagerProfileShow')),
  SUPERVISOR: Splitter(() => import('../supervisor/SupervisorProfileShow')),
}

class ProfileShowContainer extends Component {
  componentWillMount() {
    if (isEmptyObject(this.props.userProfile)) {
      const { dispatch, userId, userType } = this.props
      dispatch({ type: FETCH_USER_PROFILE, userId, userType })
    }
  }

  render() {
    const { userType } = this.props
    const ComponentToRender = ComponentByUserType[userType]

    return ComponentToRender ? <ComponentToRender /> : <div />
  }
}

function mapStateToProps(state) {
  return {
    ...profileSelector(state),
    ...authSelector(state),
  }
}

export default connect(mapStateToProps)(ProfileShowContainer)



// WEBPACK FOOTER //
// ./src/components/dashboard/ProfileShowContainer.js